export default "__VITE_ASSET__Br9thT9r__"